import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../utils/api';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSelector from './Layout/LanguageSelector';
import './Auth.css';

const VerifyEmail = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');
  const successRef = useRef(false);
  const requestedRef = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage(t('auth.invalidVerificationLink', 'Invalid verification link. Please use the link from your email.'));
      return;
    }

    // Prevent double call (e.g. React Strict Mode or double mount)
    if (requestedRef.current) return;
    requestedRef.current = true;

    const verify = async () => {
      try {
        const response = await api.get('/auth/verify-email', { params: { token } });
        if (response.data.success) {
          successRef.current = true;
          setStatus('success');
          setMessage(response.data.message || t('auth.emailVerifiedSuccess', 'Email verified successfully. You can now log in.'));
        } else {
          if (!successRef.current) {
            setStatus('error');
            setMessage(response.data.message || t('auth.verificationFailed', 'Verification failed. Please try again or request a new link.'));
          }
        }
      } catch (err) {
        if (!successRef.current) {
          setStatus('error');
          setMessage(err.response?.data?.message || t('auth.verificationFailed', 'Verification failed. Please try again or request a new link.'));
        }
      }
    };

    verify();
  }, [token, t]);

  return (
    <div className="auth-page">
      <div className="auth-header-row">
        <LanguageSelector />
      </div>
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-logo-container">
            <img src="/images/logo-Photoroom.png" alt="Cleaning Service Logo" className="auth-logo" />
          </div>
          <h2>{t('auth.verifyEmail', 'Verify Email')}</h2>
          {status === 'loading' && (
            <p style={{ textAlign: 'center', color: '#666' }}>{t('auth.verifying', 'Verifying your email...')}</p>
          )}
          {status === 'success' && (
            <>
              <div className="success-message">{message}</div>
              <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <Link to="/login" className="btn btn-primary btn-block" style={{ display: 'inline-block', textDecoration: 'none' }}>
                  {t('auth.login', 'Login')}
                </Link>
              </div>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="error-message">{message}</div>
              <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <Link to="/login" style={{ color: '#2c7a7b', fontWeight: '600' }}>{t('auth.backToLogin', 'Back to Login')}</Link>
                <span style={{ margin: '0 8px' }}>{' | '}</span>
                <Link to="/register" style={{ color: '#2c7a7b', fontWeight: '600' }}>{t('auth.register', 'Register')}</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
